var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('f7-page-content',{staticClass:"splash"},[_c('f7-preloader',{attrs:{"color":"blue"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }